/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type JoblistingType = "OT" | "PP" | "SI" | "%future added value";
export type JoblistingsContainer_joblisting = {
    readonly slug: string;
    readonly id: string;
    readonly type: JoblistingType;
    readonly title: string;
    readonly url: string;
    readonly deadline: string | null;
    readonly towns: ReadonlyArray<{
        readonly name: string;
    }>;
    readonly company: {
        readonly name: string;
        readonly logo: string | null;
    };
    readonly __typename: "Joblisting";
    readonly " $refType": "JoblistingsContainer_joblisting";
};
export type JoblistingsContainer_joblisting$data = JoblistingsContainer_joblisting;
export type JoblistingsContainer_joblisting$key = {
    readonly " $data"?: JoblistingsContainer_joblisting$data;
    readonly " $fragmentRefs": FragmentRefs<"JoblistingsContainer_joblisting">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JoblistingsContainer_joblisting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Town",
      "kind": "LinkedField",
      "name": "towns",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "height",
              "value": 260
            },
            {
              "kind": "Literal",
              "name": "width",
              "value": 800
            }
          ],
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": "logo(height:260,width:800)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Joblisting",
  "abstractKey": null
};
})();
(node as any).hash = 'e56f492fc3c46dfa91b09ec085744871';
export default node;
